import { Box, Stack } from 'braid-design-system';
import React, { type FC } from 'react';

import { StaticPageProvider } from 'src/components';
import type { PageProps } from 'src/shared/types';

import { PageIntro, PromoTiles, StepsBlock } from '../../components';
import { promoTileData, stepsList } from '../../data';

const FrontPageComponent: FC<{ jobAdId: string }> = ({ jobAdId }) => {
  const trackingProps = {
    page: 'create qr code',
    eventName: 'create_qr_code_displayed',
    siteSection: 'products',
    currentPage: 'create qr code',
    subSection: 'qr-code',
    linkName: 'create_qr_code_displayed',
    jobId: jobAdId,
  };

  const StaticPageProps: PageProps = {
    title: 'QR code',
    returnUrl: '/products/qr-code',
    activeTab: 'Products',
    activeSubTab: 'QR code',
    ...trackingProps,
  };

  return (
    <StaticPageProvider {...StaticPageProps}>
      <Box background="surface" style={{ overflowX: 'hidden' }}>
        <Stack space="xlarge">
          <Box paddingX="gutter" background="formAccentSoft">
            <PageIntro jobAdId={jobAdId} />
          </Box>
          <StepsBlock
            title="Follow these easy steps to get your job ad seen by more people"
            list={stepsList}
          />
          <Box background="formAccentSoft">
            <PromoTiles
              title="A simple way to get your ad seen by more people"
              tiles={promoTileData}
            />
          </Box>
        </Stack>
      </Box>
    </StaticPageProvider>
  );
};

export default FrontPageComponent;
